// Tiny site-sound manager — spray swoosh on booking success + optional wash ambience.
let ambience = null;

export function playConfirm() {
  try {
    const a = new Audio("/sounds/wash-confirm.wav");
    a.volume = 0.7;
    a.play().catch(() => {});
  } catch {}
}

function ensureEl() {
  if (!ambience) {
    ambience = new Audio("/sounds/wash-ambience.wav");
    ambience.loop = true;
    ambience.volume = 0;
  }
  return ambience;
}

export function startAmbience() {
  const a = ensureEl();
  a.play().catch(() => {});
  const target = 0.4;
  const fade = setInterval(() => {
    if (a.volume < target) a.volume = Math.min(target, a.volume + 0.05);
    else clearInterval(fade);
  }, 100);
}

export function stopAmbience() {
  if (!ambience) return;
  const a = ambience;
  const fade = setInterval(() => {
    a.volume = Math.max(0, a.volume - 0.08);
    if (a.volume <= 0) {
      a.pause();
      clearInterval(fade);
    }
  }, 80);
}

export function ambienceOn() {
  return !!ambience && !ambience.paused;
}